import Footer from "../components/Footer";

import {Link} from "react-router-dom";

import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import {useEffect} from "react";
import usePageReady from "../../shared/usePageReady";

const metadata = {
    title: `Privacy Policy || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function PrivacyPolicyPage({onPageReady}) {
    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata}/>
            <Header/>
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span/>
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Privacy Policy</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="s-title-page">
                    <div className="container">
                        <h4 className="s-title letter-0 text-center">Privacy Policy</h4>
                    </div>
                </section>
                {/* /Title Page */}
                {/* Privacy policy */}
                <section className="s-term-user flat-spacing-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="content">
                                    <div className="term-item">
                                        <p className="term-title">1. Collecting Personal Information</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                When you visit the Site, we collect certain information about your
                                                device, your interaction with the Site, and information necessary to
                                                process your purchases. We may also collect additional information if
                                                you contact us for customer support. In this Privacy Policy, we refer to
                                                any information that can uniquely identify an individual (including the
                                                information below) as “Personal Information”. See the list below for
                                                more information about what Personal Information we collect and why.


                                            </p>
                                            <p className="term-text">
                                                Device information
                                                • Examples of Personal Information collected: version of web browser, IP
                                                address, time zone, cookie information, what sites or products you view,
                                                search terms, and how you interact with the Site.
                                                • Purpose of collection: to load the Site accurately for you, and to
                                                perform analytics on Site usage to optimize our Site.
                                                • Source of collection: Collected automatically when you access our Site
                                                using cookies, log files, web beacons, tags, or pixels
                                            </p>
                                            <p className="term-text">
                                                Order information
                                                • Examples of Personal Information collected: name, billing address,
                                                shipping address, payment information (including credit card numbers),
                                                email address, and phone number.
                                                • Purpose of collection: to provide products or services to you to
                                                fulfill our contract, to process your payment information, arrange for
                                                shipping, and provide you with invoices and/or order confirmations,
                                                communicate with you, screen our orders for potential risk or fraud, and
                                                when in line with the preferences you have shared with us, provide you
                                                with information or advertising relating to our products or services.
                                                • Source of collection: collected from you.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">2. Minors</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                The Site is not intended for individuals under the age of 13. We do not
                                                intentionally collect Personal Information from children. If you are the
                                                parent or guardian and believe your child has provided us with Personal
                                                Information, please contact us at the address below to request deletion.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">
                                            3. Sharing Personal Information
                                        </p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                We share your Personal Information with service providers to help us
                                                provide our services and fulfill our contracts with you, as described
                                                above. For example:
                                                • We may share your Personal Information to comply with applicable laws
                                                and regulations, to respond to a subpoena, search warrant or other
                                                lawful request for information we receive, or to otherwise protect our
                                                rights.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">4. Behavioural Advertising</p>
                                        <p className="term-text">
                                            As described above, we use your Personal Information to provide you with
                                            targeted advertisements or marketing communications we believe may be of
                                            interest to you. For example:
                                            • We use Google Analytics to help us understand how our customers use the
                                            Site. You can read more about how Google uses your Personal Information
                                            here: https://policies.google.com/privacy?hl=en.You can also opt-out of
                                            Google Analytics here: https://tools.google.com/dlpage/gaoptout.
                                            • We share information about your use of the Site, your purchases, and your
                                            interaction with our ads on other websites with our advertising partners. We
                                            collect and share some of this information directly with our advertising
                                            partners, and in some cases through the use of cookies or other similar
                                            technologies (which you may consent to, depending on your location).

                                        </p>
                                        <p className="term-text">
                                            For more information about how targeted advertising works, you can visit the
                                            Network Advertising Initiative’s (“NAI”) educational page at
                                            http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
                                            You can opt out of targeted advertising by:
                                            FACEBOOK - https://www.facebook.com/settings/?tab=adsGOOGLE -
                                            https://www.google.com/settings/ads/anonymousBING -
                                            https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                                            Additionally, you can opt out of some of these services by visiting the
                                            Digital Advertising Alliance’s opt-out portal at:
                                            http://optout.aboutads.info/.

                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">5. Using Personal Information</p>
                                        <p className="term-text">
                                            We use your personal Information to provide our services to you, which
                                            includes: offering products for sale, processing payments, shipping and
                                            fulfillment of your order, and keeping you up to date on new products,
                                            services, and offers.
                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">6. Lawful basis</p>
                                        <p className="term-text">
                                            Pursuant to the General Data Protection Regulation (“GDPR”), if you are a
                                            resident of the European Economic Area (“EEA”), we process your personal
                                            information under the following lawful bases:
                                            Your consent;The performance of the contract between you and the
                                            Site;Compliance with our legal obligations;To protect your vital
                                            interests;To perform a task carried out in the public interest;For our
                                            legitimate interests, which do not override your fundamental rights and
                                            freedoms.

                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">7. Retention</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                When you place an order through the Site, we will retain your Personal
                                                Information for our records unless and until you ask us to erase this
                                                information. For more information on your right of erasure, please see
                                                the ‘Your rights’ section below.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">8. Automatic decision-making</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                If you are a resident of the EEA, you have the right to object to
                                                processing based solely on automated decision-making (which includes
                                                profiling), when that decision-making has a legal effect on you or
                                                otherwise significantly affects you.
                                                We engage in fully automated decision-making that has a legal or
                                                otherwise significant effect using customer data.
                                                Services that include elements of automated decision-making include:
                                                Temporary denylist of IP addresses associated with repeated failed
                                                transactions. This denylist persists for a small number of
                                                hours.Temporary denylist of credit cards associated with denylisted IP
                                                addresses. This denylist persists for a small number of days.

                                            </p>
                                        </div>
                                    </div>

                                    <p className="term-title">Your Rights</p>
                                    <div className="term-item">
                                        <p className="term-title">9. GDPR</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                If you are a resident of the EEA, you have the right to access the
                                                Personal Information we hold about you, to port it to a new service, and
                                                to ask that your Personal Information be corrected, updated, or erased.
                                                If you would like to exercise these rights, please contact us through
                                                the contact information below.
                                                Your Personal Information will be initially processed in Ireland and
                                                then will be transferred outside of Europe for storage and further
                                                processing, including to Canada and the United States.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">10. CCPA</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                If you are a resident of California, you have the right to access the
                                                Personal Information we hold about you (also known as the ‘Right to
                                                Know’), to port it to a new service, and to ask that your Personal
                                                Information be corrected, updated, or erased. If you would like to
                                                exercise these rights, please contact us through the contact information
                                                below .
                                                If you would like to designate an authorized agent to submit these
                                                requests on your behalf, please contact us at the address below.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">11. Cookies</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                A cookie is a small amount of information that’s downloaded to your
                                                computer or device when you visit our Site. We use a number of different
                                                cookies, including functional, performance, advertising, and social
                                                media or content cookies. Cookies make your browsing experience better
                                                by allowing the website to remember your actions and preferences (such
                                                as login and region selection). This means you don’t have to re-enter
                                                this information each time you return to the site or browse from one
                                                page to another. Cookies also provide information on how people use the
                                                website, for instance whether it’s their first time visiting or if they
                                                are a frequent visitor.
                                            </p>

                                            <p className="term-text">
                                                The length of time that a cookie remains on your computer or mobile
                                                device depends on whether it is a “persistent” or “session” cookie.
                                                Session cookies last until you stop browsing and persistent cookies last
                                                until they expire or are deleted. Most of the cookies we use are
                                                persistent and will expire between 30 minutes and two years from the
                                                date they are downloaded to your device.
                                                You can control and manage cookies in various ways. Please keep in mind
                                                that removing or blocking cookies can negatively impact your user
                                                experience and parts of our website may no longer be fully accessible.
                                                Most browsers automatically accept cookies, but you can choose whether
                                                or not to accept cookies through your browser controls, often found in
                                                your browser’s “Tools” or “Preferences” menu. For more information on
                                                how to modify your browser settings or how to block, manage or filter
                                                cookies can be found in your browser’s help file or through such sites
                                                as www.allaboutcookies.org.
                                                Additionally, please note that blocking cookies may not completely
                                                prevent how we share information with third parties such as our
                                                advertising partners. To exercise your rights or opt-out of certain uses
                                                of your information by these parties, please follow the instructions in
                                                the “Behavioural Advertising” section above.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">12. Do Not Track</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                Please note that because there is no consistent industry understanding
                                                of how to respond to “Do Not Track” signals, we do not alter our data
                                                collection and usage practices when we detect such a signal from your
                                                browser.
                                            </p>


                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">13. Changes</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                We may update this Privacy Policy from time to time in order to reflect,
                                                for example, changes to our practices or for other operational, legal,
                                                or regulatory reasons.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">14. Contact</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                For more information about our privacy practices, if you have questions,
                                                or if you would like to make a complaint, please contact us by e-mail
                                                luxandcouk@gmail.com or mail using the details provided below
                                                Flat 17 Belgrave house 92-94 Belgrave road SW1V 2BJ United Kingdom
                                                If you are not satisfied with our response to your complaint, you have
                                                the right to lodge your complaint with the relevant data protection
                                                authority. You can contact your local data protection authority.

                                            </p>
                                            <a href="mailto:support@luxnco.com" className="link">
                                                support@luxnco.com
                                            </a>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* /Privacy policy */}
            </>

            <Footer/>
        </>
    );
}
